import React, {Component} from 'react';
import {ModalBody} from 'reactstrap';
import { ShopifyLinkComponent } from '../link_acocunts/ShopifyLink';
import { TiendaNubeLinkComponent } from '../link_acocunts/TiendaNubeLink';
import {
    SHOPIFY_CHANNEL,
    TIENDA_NUBE_CHANNEL,
    CHANNEL_TYPE_PAID_MEDIA,
    CHANNEL_INFO_BY_CHANNEL
} from "../../channels/channels";
import { withTranslation } from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { PaidMediaReconnectFlow } from './PaidMediaReconnectFlow';

class ReconnectAdAccountFormClass extends Component {
    render() {
        const { t } = this.props;
        const adAccountData = this.props.adAccountData;

        if (!adAccountData) {
            return null;
        }

        const channelInfo = CHANNEL_INFO_BY_CHANNEL[adAccountData.channel];
        if (channelInfo && channelInfo.channelType === CHANNEL_TYPE_PAID_MEDIA) {
            return <PaidMediaReconnectFlow
                adAccountData={adAccountData}
                onReconnected={this.props.onReconnected}
                onToggle={this.props.onToggle}
            />;
        }

        const commonProps = {
            hasConnection: false,
        };

        let linkComponent = null;
        switch(adAccountData.channel) {
            case SHOPIFY_CHANNEL:
                linkComponent = <ShopifyLinkComponent {...commonProps} subdomain={adAccountData.store_subdomain} disabled={!adAccountData.store_subdomain} />;
                break;
            case TIENDA_NUBE_CHANNEL:
                linkComponent = <TiendaNubeLinkComponent {...commonProps} disabled={false} />;
                break;
            default:
                linkComponent = <p>La reconexión para el canal {adAccountData.channel} no está implementada.</p>;
        }

        return (
            <ModalBody>
                <div className="modal-section">
                    <p>Para reconectar la cuenta es necesario que vuelva a autenticarse en la plataforma.</p>
                    {adAccountData.channel === TIENDA_NUBE_CHANNEL && (
                        <div className="alert alert-info" style={{ fontSize: '0.9em' }}>
                            <FontAwesomeIcon icon="info-circle" style={{ marginRight: '0.5em' }} />
                            {t('add_store_modal.tienda_nube_session_tip')}
                        </div>
                    )}
                    {linkComponent}
                </div>
            </ModalBody>
        )
    }
}

export const ReconnectAdAccountForm = withTranslation()(ReconnectAdAccountFormClass); 